// ══════════════════════════════════════════════════════════════════════════════
//  src/sesion.js
//  ¿HAY ALGUIEN DENTRO, Y A DÓNDE LE TOCA ATERRIZAR?
//
//  ── EL FALLO QUE OBLIGÓ A ESCRIBIR ESTO ────────────────────────────────────
//  «/» es el Motor de Diagnóstico para todo el mundo, sin mirar si hay sesión.
//  Era una decisión asumida mientras NSL vivía en una dirección de Vercel que
//  nadie escribía a mano. Con el dominio conectado dejó de serlo: un alumno que
//  escribe `non-stop-learning.com` —que es lo que va a hacer— cae en el
//  diagnóstico anónimo, y si ya lo había terminado alguna vez ve el resumen con
//  un botón que dice «Quiero mi plan» y lo manda a REGISTRARSE. Teniendo cuenta.
//
//  No es un fallo que rompa nada: es peor. Funciona, no da error, y le enseña a
//  un cliente de pago la puerta de la calle todos los días.
//
//  ── POR QUÉ AQUÍ Y NO UN `if` EN LA RUTA ───────────────────────────────────
//  Porque el destino tiene que ser EL MISMO que el del login. Si el login manda
//  al gimnasio y la raíz manda al panel, el alumno aterriza en un sitio distinto
//  según por dónde entró, y eso se nota. Estando en un fichero, cambiar el
//  destino los cambia a los dos.
//
//  ── ESTO NO ES SEGURIDAD ───────────────────────────────────────────────────
//  `localStorage` se edita en dos clics. Un token caducado manda al alumno al
//  gimnasio, donde `ProtectedRoute` lo comprueba contra el servidor y lo
//  devuelve al login — que es lo correcto: «vuelve a entrar» es mejor respuesta
//  que «haz el diagnóstico otra vez».
// ══════════════════════════════════════════════════════════════════════════════

/** El usuario guardado, o `null` si no hay sesión utilizable. */
export function usuarioDeLaSesion() {
    try {
        if (!localStorage.getItem('token')) return null;
        const crudo = localStorage.getItem('user');
        if (!crudo) return null;
        const u = JSON.parse(crudo);
        return u && typeof u === 'object' ? u : null;
    } catch {
        return null;   // ventana privada, almacenamiento bloqueado o JSON roto
    }
}

export const haySesion = () => usuarioDeLaSesion() !== null;

// ══════════════════════════════════════════════════════════════════════════════
//  A DÓNDE ATERRIZA CADA UNO
//
//  ── AL ALUMNO LO RECIBE SPACY, NO EL GIMNASIO ──────────────────────────────
//  Rob, 27-09-2026: «cuando alguien se loguee, o sea su primera visita después
//  de loguearse o registrarse, que los reciba la página del coach, no la del
//  gym. Así, si es la primera vez, Spacy ya sabe saludar y dar el recorrido,
//  entrenar… en fin, tiene toda la potencia».
//
//  El gimnasio es una estantería: enseña lo que hay y espera a que el alumno
//  sepa elegir. El Coach es alguien que le dice qué le toca hoy y por qué, y
//  al que llega por primera vez le cuenta la casa entera. Recibir con una
//  estantería a quien acaba de entrar es pedirle que decida antes de saber.
//
//  ── Y AL PROFESOR TAMBIÉN. A TODOS ─────────────────────────────────────────
//  La primera versión de esto mandaba al profesor a su agenda, con dos
//  argumentos: que abre la app para eso, y que `/coach` exigía
//  `learning_profile` —que un profesor creado desde el CRM no tiene—, así que
//  habría rebotado al onboarding de alumno sin llegar nunca a su panel.
//
//  Rob lo corrigió el 27-09-2026: «esto no; al profesor lo va a recibir Spacy,
//  y vamos a hacer más inteligente a Spacy para que sepa manejar el calendario
//  tanto para alumno, teachers y yo que soy el admin, que sería el global».
//
//  El segundo argumento era real y se ha arreglado donde tocaba: la guardia ya
//  no le pide el onboarding de alumno a quien no lo es (ver `ProtectedRoute`).
//  El primero era una suposición mía sobre lo que quiere ver al entrar, y no me
//  correspondía: Spacy recibe a todo el mundo y cada uno ve lo suyo.
// ══════════════════════════════════════════════════════════════════════════════

export const DESTINO_DEL_ALUMNO = '/coach';

/**
 * A dónde mandar a este usuario, sea de donde sea que lo tengamos en la mano.
 *
 * Hoy es el mismo sitio para todos, y la función sigue existiendo por dos
 * razones: el login ya tiene el usuario recién llegado del servidor y no
 * necesita ir a buscarlo a `localStorage` —que en ese instante puede que
 * todavía no se haya escrito—, y el día que un rol necesite otra puerta se
 * cambia aquí y no en los tres sitios por los que se entra.
 */
export function destinoDe(usuario) {
    if (!usuario) return null;
    return DESTINO_DEL_ALUMNO;
}

/**
 * A dónde mandar a quien ya está dentro. `null` si no hay nadie.
 *
 * ⚠️  Este destino y el del login tienen que ser EL MISMO. Si la raíz manda al
 *     coach y el login al gimnasio, el alumno aterriza en un sitio distinto
 *     según por dónde entró, y eso se nota. Por eso los dos salen de aquí.
 */
export function destinoDeLaSesion() {
    return destinoDe(usuarioDeLaSesion());
}
